import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "slashWhenNullOrZero" })
export class SlashWhenNullOrZeroPipe implements PipeTransform {
  transform(value: number): string {
    return (value && !isNaN(value) && value != 0) ? value.toFixed(2) : "-";
  }
}
